"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

var _Stack = _interopRequireDefault(require("../../layout/Stack"));

var _Handle = _interopRequireDefault(require("../Handle"));

var _utils = require("../../utils/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SideBarContainer = (0, _styledComponents["default"])(_Row["default"]).withConfig({
  displayName: "SideBar__SideBarContainer",
  componentId: "v8e2k4-0"
})(["align-items:center;height:100vh;transition:width 0.5s;flex:0 0 auto;", ""], function (props) {
  return props.collapsed ? (0, _styledComponents.css)(["width:calc(6rem + 2px);"]) : (0, _styledComponents.css)(["width:calc(21rem + 2px);"]);
});
var CollapsableContainer = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "SideBar__CollapsableContainer",
  componentId: "v8e2k4-1"
})(["flex-grow:1;transition:flex 0.5s;height:100%;overflow:hidden;footer{flex-shrink:1;}"]);
/**
 *
 * #### Side content component

SideBar is a container component, that is designed to sit on the left-hand side of the page taking up the full height of the window. It  comes with a handle is used to change its 'collapsed' state.

Following the current design pattern, it should house the following components in this order:

**NavHeader**
**SideBarNavItemContainer**
**NavFooter**
 */

var SideBar = function SideBar(_ref) {
  var _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(SideBarContainer, {
    element: "aside",
    collapsed: collapsed,
    "aria-expanded": !collapsed
  }, /*#__PURE__*/_react["default"].createElement(CollapsableContainer, {
    collapsed: collapsed
  }, (0, _utils.clonePropsToChildren)(children, {
    collapsed: collapsed
  })), /*#__PURE__*/_react["default"].createElement(_Handle["default"], {
    collapsed: collapsed,
    status: collapsed ? 'pull' : 'push',
    onClick: onChange,
    cursor: "pointer"
  }));
};

var _default = SideBar;
exports["default"] = _default;